import React from "react";
import {
  Box,
  Grid,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Checkbox,
} from "@mui/material";
import MimeIcon from "./MimeIcon";
import { humanReadableSize } from "./app/utils";

export interface FileItem {
  key: string;
  size: number;
  uploaded: string;
  httpMetadata: { contentType: string };
  customMetadata?: { thumbnail?: string };
}

function extractFilename(key: string) {
  return key.split("/").pop();
}

export function encodeKey(key: string) {
  return key.split("/").map(encodeURIComponent).join("/");
}

export function isDirectory(file: FileItem) {
  return file.httpMetadata?.contentType === "application/x-directory";
}

function FileGrid({
  files,
  onCwdChange,
  multiSelected,
  onMultiSelect,
  emptyMessage,
}: {
  files: FileItem[];
  onCwdChange: (newCwd: string) => void;
  multiSelected: string[] | null;
  onMultiSelect: (key: string) => void;
  emptyMessage?: React.ReactNode;
}) {
  return files.length === 0 ? (
    emptyMessage
  ) : (
    <Grid container sx={{ paddingBottom: "48px" }}>
      {files.map((file) => (
        <Grid item key={file.key} xs={12} sm={6} md={4} lg={3} xl={2}>
          <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
            {/* 复选框 - 始终显示 */}
            <Checkbox
              checked={multiSelected?.includes(file.key) || false}
              onChange={() => onMultiSelect(file.key)}
              onClick={(e) => e.stopPropagation()}
              size="small"
              sx={{ mr: 0.5 }}
            />
            
            {/* 文件项 - 点击执行默认操作 */}
            <ListItemButton
              selected={multiSelected?.includes(file.key)}
              onClick={() => {
                if (isDirectory(file)) {
                  onCwdChange(file.key + "/");
                } else {
                  window.open(
                    `/webdav/${encodeKey(file.key)}`,
                    "_blank",
                    "noopener,noreferrer"
                  );
                }
              }}
              onContextMenu={(e) => {
                e.preventDefault();
                onMultiSelect(file.key);
              }}
              sx={{ 
                userSelect: "none",
                flexGrow: 1,
              }}
            >
              <ListItemIcon>
                {file.customMetadata?.thumbnail ? (
                  <img
                    src={`/webdav/_$flaredrive$/thumbnails/${file.customMetadata.thumbnail}.png`}
                    alt={file.key}
                    style={{ width: 36, height: 36, objectFit: "cover" }}
                  />
                ) : (
                  <MimeIcon contentType={file.httpMetadata.contentType} />
                )}
              </ListItemIcon>
              <ListItemText
                primary={extractFilename(file.key)}
                primaryTypographyProps={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
                secondary={
                  <React.Fragment>
                    <Box
                      sx={{
                        display: "inline-block",
                        minWidth: "160px",
                        marginRight: 1,
                      }}
                    >
                      {new Date(file.uploaded).toLocaleString()}
                    </Box>
                    {!isDirectory(file) && humanReadableSize(file.size)}
                  </React.Fragment>
                }
              />
            </ListItemButton>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
}

export default FileGrid;
